export const INHOUSE_GAME_BREAKPOINT = 720
